import React from 'react'
import TaskLogList from './components/view/taskLogList'


const TaskLogs = () => {
    return (
        <div>
            <div
                className={'container'}
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >
                <TaskLogList />
            </div>
        </div>
    )
}

export default TaskLogs